import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'sal_center': {
    title: '公司/营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    unSearchRole: 'WLY001'
  },
  'sal_center_name': {
    title: '公司/营销单元描述',
    type: 'input'
  }
}

export default {
  'plan_number': {
    title: '销售计划编号',
    type: 'input',
    equation: all,
    slot: true
  },
  'report_type': {
    describe: true,
    title: '提报类型',
    type: 'select',
    equation: city,
    dictionary: 'A0001',
    width: 100
  },
  'plan_type': {
    describe: true,
    title: '计划类型',
    showDescribeInput: true,
    describeTitle: '计划类型描述',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 200
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    },
    unSearchRole: 'WLY001'
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 200,
    unSearchRole: 'WLY001'
  },
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009',
    unSearchRole: 'WLY001'
  },
  'sal_center_name': {
    title: '公司/营销单元'
  },
  'base': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base',
    unSearchRole: 'WLY001'
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    showDescribeInput: true,
    describeTitle: '存货分类描述',
    type: 'select',
    equation: all,
    dictionary: 'A0019'
  },
  'sales_emp_name': {
    title: '业务员',
    type: 'input',
    equation: cusname
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: city
  },
  'monat': {
    title: '月份',
    type: 'select',
    equation: city,
    dictionary: 'month'
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue),
    defaultVal: new Date()
  },
  'total_qty': {
    title: '总计划量(件)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'initplan_qty': {
    title: '初始计划量(件)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'atp_qty': {
    title: '已占用计划量(件)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'billing_qty': {
    title: '已开票计划量(件)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'remain_qty': {
    title: '剩余可用计划量(件)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'total_bot': {
    title: '总计划量(瓶)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'initplan_bot': {
    title: '初始计划量(瓶)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'atp_bot': {
    title: '已占用计划量(瓶)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'billing_bot': {
    title: '已开票计划量(瓶)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'remain_bot': {
    title: '剩余可用计划量(瓶)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },

  'total_amt': {
    title: '总计划额(万元)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'initplan_amt': {
    title: '初始计划额(万元)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'atp_amt': {
    title: '已占用计划额(万元)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'billing_amt': {
    title: '已开票计划额(万元)',
    width: 150,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'remain_amt': {
    title: '剩余可用计划额(万元)',
    width: 160,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'block_flag': {
    title: '是否冻结',
    type: 'whether',
    equation: city
  }
}



// WEBPACK FOOTER //
// ./src/views/sale-plan-manage/config/salePlanTotalList.js